<template>
  <div v-if="show" class="go-to-v2-banner">
    <div class="go-to-v2-banner__text">
      <feather-icon icon="InfoIcon" svgClasses="w-5 h-5" class="go-to-v2-banner__icon" />
      <span>
        <strong>Your clinic has moved to the new Fresh platform.</strong>
        Continue there to place orders and manage your account.
      </span>
    </div>
    <vs-button
      color="#fff"
      text-color="#0E4333"
      class="go-to-v2-banner__cta"
      icon-pack="feather"
      icon="icon-arrow-right"
      icon-after
      @click="goToV2"
    >
      Go to the new Fresh platform
    </vs-button>
  </div>
</template>

<script>
import { getActiveMigrationTarget, redirectToMigratedPlatform } from '@/utils/checkOrgMigration';
import { isStoreOrOrdersPath } from '@/utils/platformMigrationHelper';
import { resolveV2Url } from '@/utils/goToV2Target';

export default {
  name: 'GoToV2Banner',
  computed: {
    isLoggedIn() {
      return (
        localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}LoggedIn`) === 'true'
      );
    },
    migrationTarget() {
      return getActiveMigrationTarget();
    },
    v2Url() {
      return resolveV2Url(this.migrationTarget.orgPlatformUrl, process.env.VUE_APP_REGION);
    },
    show() {
      return (
        this.isLoggedIn &&
        this.migrationTarget.migrated &&
        !isStoreOrOrdersPath(this.$route.path) &&
        Boolean(this.v2Url)
      );
    },
  },
  methods: {
    goToV2() {
      if (this.v2Url) redirectToMigratedPlatform(this.v2Url);
    },
  },
};
</script>

<style scoped>
.go-to-v2-banner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  margin-bottom: 1.5rem;
  padding: 14px 20px;
  background: #0e4333;
  border-radius: 6px;
  color: #fff;
}
.go-to-v2-banner__text {
  display: flex;
  align-items: center;
  gap: 10px;
  line-height: 1.4;
}
.go-to-v2-banner__icon {
  flex-shrink: 0;
  color: #84cdb8;
}
.go-to-v2-banner__cta {
  flex-shrink: 0;
  font-weight: 600;
}
</style>
